<template>
    <AddPrixProduitCondTypeClient2/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import AddPrixProduitCondTypeClient2 from "@/components/GesCom/PrixProduitCondTypeClient/AddPrixProduitCondTypeClient2.vue";
  
    export default defineComponent({
      name: "AddPrixProduitCondTypeClientPage2",
      components: {
        AddPrixProduitCondTypeClient2,
      },
    });
  </script>